import Table from "../../table/Table"
import ApiService from "../../../services/apiService"
import { useCallback, useEffect, useState } from "react"
import LeftIcon from "../../svg/LeftButton"
import RightIcon from "../../svg/RightIcon"

type wua = {
    Id:string|number|undefined
}
const GetBeneficiaryData = ({Id}:wua) =>{
    const[beneficiaryData,setBeneficiaryData] = useState()
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
      
     const getBeneficiary = async () =>{
          
        try{
              const response = await ApiService.axiosApi(`/chaklevelsummary/beneficiary`,{
                 method:'GET',
                 params:{
                     WuaId:Id,
                     pageNumber: pageNumber,
                     pageSize: pageSize,
                 }
              })

              if(response.success){
                  setBeneficiaryData(response.data.data)
                  setTotalCount(response.data.totalCount)
                  
              }else{
                 console.log('unable to get subchak')
              }
        }catch(e){
             console.log(e)
        }

     }

     useEffect(()=>{
          if(Id){
            getBeneficiary();
          }
     },[Id,pageNumber, pageSize])


     const totalPages = Math.ceil(totalCount / pageSize);

     const handleNext = useCallback(() => {
       setPageNumber((prev) => Math.min(totalPages, prev + 1));
     }, [setPageNumber, totalPages]);
   
     const handlePrev = useCallback(() => {
       setPageNumber((prev) => Math.max(1, prev - 1));
     }, [setPageNumber, totalPages]);


    return(
         <>
          { beneficiaryData != null ?   <Table
                        isAction={false}
                        data={beneficiaryData}
                        columns={[
                            {header:'Sub-Chak',accessor:'chakName'},
                            { header: ' Area(HA)', accessor: 'cca_Acre' },
                            {header:'Name Of Beneficiaries',accessor:'nameOfBeneficiary'},
                            
                        ]}

                        buttons={[
                            
                        ]}
                    />
                  :''  }

<div
            className=" d-flex justify-content-end align-content-center"
            style={{ marginRight: "10px", marginTop: "10px" }}
          >
            <p style={{ marginRight: "10px", marginTop: "8px" }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
            
         </>
    )
}

export default GetBeneficiaryData